import { Component, OnInit } from '@angular/core';
import { PatientCaseListDataModel } from '../../models/PatientCaseListData2.model';
import { PatientServiceService } from '../../services/PatientService.service';
import { PatientAppointmentService } from '../../services/PatientAppointment.service';
import { EventSettingsModel, View } from '@syncfusion/ej2-schedule';
import { SchedulePatientModel } from '../../models/SchedulePatient.model';
import { Router } from '@angular/router';
import { SchedulerEventModel } from '../../../HospitalPanel/models/SchedulerEventModel';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';


@Component({
  selector: 'app-book',
  templateUrl: './book.component.html',
  styleUrls: ['./book.component.css']
})
export class PaBookComponent implements OnInit {
  htmlView: boolean = true;
  errHeader: string;
  errMessage: string[] = [];
  showBook: boolean = false;
  bookApp: boolean = false;
  showBookModal: boolean = false;
  dateSelect;
  caseList: PatientCaseListDataModel[];
  selectedCase: string;
  doctorInfo;
  doctorId;
  doctorSlots: any[];
  showOverlayBook: boolean;
  minDate;
  showDoc: boolean = false;
  showSch: boolean = false;
  scheduleModal: SchedulePatientModel;
  doctorList: any[];
  scheduleDocId: string;
  searchTermCaseList: string = "";
  showOverlay: boolean = false;
  scheduleEaId: any;
  searchTermDocList: string = "";
  selectedAppointmentStartTime;
  selectedAppointmentEndTime;
  selectedAppointmentDate;
  selectedCaseName: string;
  showBookLoader:boolean=false;
  showSmallLoader:boolean = false;
  public ScheduleData: object[] = [{
    id: 1,
    subject: '',
    fromTime: new Date(2019, 8, 1, 15, 0, 0, 0),
    toTime: new Date(2019, 8, 1, 15, 30, 0, 0),
  }];
  public EventSettingsData: EventSettingsModel = {
    dataSource: this.getAppointmentData(),
    fields: {
      id: 'Id',
      subject: { name: 'Subject' },
      startTime: { name: 'fromTime' },
      endTime: { name: 'toTime' },
    }
  };
  docEvents: SchedulerEventModel[];
  public NewView: View = 'TimelineDay';
  public SelectedDate: Date = new Date();
  constructor(private _service: PatientServiceService, private Router: Router, private serv: PatientAppointmentService) { }

  ngOnInit() {

    this.dateSelect = new Date().toJSON().split('T')[0];
    this.minDate = new Date().toJSON().split('T')[0];
    this.getPatientCases();
    this.adjustContent();
    this.NewView = 'TimelineDay';
  }

  getAppointmentData(): object[] {
    return this.ScheduleData;
  }

  onQuickClick(event) {
    event.cancel = true;
    if (event.data.EventID != undefined && event.data.EventID != null) {
       this.alertClose();
      AlertMessages.Show("Warning",'Already Booked',AlertType.Warning);
    } else if (new Date() > event.data.fromTime) {
       this.alertClose();
      AlertMessages.Show("Warning",'you can not schedule in the past',AlertType.Warning);
    } else if (this.ScheduleData != undefined && this.ScheduleData != null) {
      if (this.ScheduleData.length > 0) {
        let existingData = this.ScheduleData.filter(i => (i["fromTime"] > event.data.fromTime && i["fromTime"] < event.data.toTime) || (i["toTime"] > event.data.fromTime && i["toTime"] < event.data.toTime));
        if (existingData.length > 0) {
           this.alertClose();
          AlertMessages.Show("Warning",'Already Booked',AlertType.Warning);
        } else {
          this.selectedAppointmentDate = event.data.fromTime;
          this.selectedAppointmentStartTime = event.data.fromTime;
          this.selectedAppointmentEndTime = event.data.toTime;
          this.showBookModal = true;
        }
      } else {
        this.selectedAppointmentDate = event.data.fromTime;
        this.selectedAppointmentStartTime = event.data.fromTime;
        this.selectedAppointmentEndTime = event.data.toTime;
        this.showBookModal = true;
      }
    }
  }


  hideBookModal() {
    this.showBookModal = false;
    this.bookApp = false;
  }

  generateData(): object[] {
    return this.ScheduleData;
  }

  adjustContent() {
    this._service.autoAdjustContent();
  }

  alertClose() {
    setTimeout(() => {
    }, 4000);
  }

  getPatientCases() {
    this.showOverlay = true;
    this.showOverlayBook = true;
    this._service.getPatientCaseList().subscribe((data) => {
      this.caseList = data as PatientCaseListDataModel[];
      this.caseList.forEach(i => {
        let fromDate = new Date(i.frmDate);
        i.fromDate = fromDate.getDate() + "-" + (1 + parseInt(fromDate.getMonth().toString())) + "-" + fromDate.getFullYear();
      })
    }, err => {
      if (err.status === 400) {
        this.errHeader = 'Server Exception';
        this.errMessage = err.error;
        this.htmlView = false;
        this.showOverlayBook = false; this.showOverlay = false;
      }
    }, () => { this.htmlView = true;  this.showOverlayBook = false; this.showOverlay = false; });
  }

  addAppointment(caseId: string, caseName: string) {
    this.selectedCase = caseId;
    this.selectedCaseName = caseName;
    this.resetData(true);

    this.getDoctorList();
  }


  getDoctorList() {
    this.showOverlayBook = true;
    this.showOverlay = true;
    this._service.getDoctorsForSchedule().subscribe((data: any[]) => {
      this.doctorList = data;
    }, err => {
      if (err.status === 400) {
        this.errHeader = 'Server Exception';
        this.errMessage = err.error;
        this.htmlView = false;
        this.showOverlay = false;
        this.showOverlayBook = false;
      }
    }, () => { this.htmlView = true;  this.showOverlay = false; this.showOverlayBook = false; });
  }

  goBack() {
    this.showSch = false;
    this.resetData(true);
    this.searchTermDocList = '';
    this.scheduleDocId = '';
    this.scheduleEaId = '';
    this.getPatientCases();
  }

  doctorCancel() {
    this.selectedCase = '';
    this.searchTermCaseList = '';
    this.searchTermDocList = '';
    this.doctorList = [];
    this.showSch = false;
    this.resetData(false);
  }

  selectDoctor(data) {
    this.scheduleDocId = data.docId;
    this.scheduleEaId = data.hospId;
    this.showDoc = false;
    this.showSch = true;
    this.doctorInfo = this.doctorList.filter(ij => ij.id == data.docId)[0];
    this.doctorId = data.docId;
    this.getDoctorAppointments(this.doctorId);
  }

  resetData(status) {
    this.showBook = status;
    this.showDoc = status;
  }

  getDoctorAppointments(doctorId) {
    let dLength = this.ScheduleData.length;
    for (let i = dLength - 1; i >= 0; i--) {
      this.ScheduleData.splice(i, 1);
    }
    if (doctorId != undefined && doctorId != '' && doctorId != null) {
      this.serv.getDoctorAppointments(doctorId).subscribe((data: any[]) => {
        if (data != undefined && data != null) {
          this.docEvents = data as SchedulerEventModel[];
          for (let i = 0; i < data.length; i++) {
            this.docEvents[i].fromTime = new Date(this.docEvents[i].start);
            this.docEvents[i].toTime = new Date(this.docEvents[i].end);
            this.ScheduleData.push(this.docEvents[i]);
          }
          this.NewView = 'TimelineDay';
          this.NewView = 'Week';
        }
      }, err => {
        if (err.status === 400) {
          this.errHeader = 'Server Exception';
          this.errMessage = err.error;
          this.htmlView = false;
          this.showOverlay = false;
          this.showOverlayBook = false;
        }
      }, () => { this.htmlView = true;  this.showOverlay = false; this.showOverlayBook = false; });
    }
  }

  routeToMyAppointment() {
    this.Router.navigate(['Patient/PAPanel/appointment']);
  }

  scheduleAppointment(reasonToBook) {
  this.bookApp = true;
  this.showSmallLoader = true;
  this.serv.schedulePatientHimself(this.doctorId, this.selectedCase, this.selectedAppointmentDate, this.selectedAppointmentStartTime, this.selectedAppointmentEndTime, this.scheduleEaId, reasonToBook).subscribe(() => {
  AlertMessages.Show('Booked', 'Your Appointment is booked', AlertType.Success);
  this.alertCloseForBook();

  },
  (error) => {
    this.showBookLoader = false;
    AlertMessages.Show('Failed', 'Could not book!', AlertType.Error);
  }).add(() => {
    this.showSmallLoader = false;
  });
  }

  alertCloseForBook() {
    setTimeout(() => {
      this.showBookLoader = false;
      this.Router.navigate(['Patient/PAPanel/appointment']);
    }, 1000);
  }
}
